import React from 'react';
import Subscribe from '../Subscribe';
import * as s from './styles';

const AccessibleHealthBanner = ({ imageSrcDesktop, imageSrcMobile }) => {
  const handleClick = () => {
    window.location.href =
      'https://docs.google.com/forms/d/e/1FAIpQLSdXvs8oON6UlCO-t-o0Rpje6qgXwFHcNd_jgWKC5BNd600H6g/viewform?pli=1';
  };

  return (
    <s.BannerContainer
      imageSrcDesktop={imageSrcDesktop}
      imageSrcMobile={imageSrcMobile}
    >
      <s.Overlay />
      <s.Content>
        <s.TextImage src='/assets/saude.svg' alt='Texto' />
        <s.Subtitle>
          Programa Especial de
          <b> Cannabis Medicinal para MEI e inscritos no Bolsa Família</b>
        </s.Subtitle>
        <s.BtnMobile>
          <Subscribe onClick={handleClick}>Inscreva-se</Subscribe>
        </s.BtnMobile>
      </s.Content>
    </s.BannerContainer>
  );
};

export default AccessibleHealthBanner;
